import TextArea from "../../../../../components/forms/text-area";

export default function IntentPrompt({ value, onChange, rootClass }) {
    return (
        <TextArea
            rootClass={rootClass}
            label="Intent Prompt"
            name="intentPrompt"
            placeholder="Trigger Conditions"
            value={value || ""}
            onChange={onChange}
        />
    );
}
